import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'

const Title = ({ name }) => (
  <Wrapper>
    <Typography variant="h5" color="primary">
      {name}
    </Typography>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 30px 0px 15px 0px;
`

Title.propTypes = {
  name: PropTypes.string.isRequired
}

export default Title



// WEBPACK FOOTER //
// ./src/components/Title/index.js